import { NgModule } from '@angular/core';
import { ResizeOnTabChangeDirective } from './resize-on-tab-change.directive';

@NgModule({
   declarations: [ResizeOnTabChangeDirective],
   imports: [],
   exports: [ResizeOnTabChangeDirective],
})
export class ResizeOnTabChangeDirectiveModule {}
